// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"468":"c20e433e","653":"fb75c144"}[chunkId] + ".chunk.js";
};